<div>
  <h2 class="custom-decorated-heading nordic-blue-900-text font-heading-3 mr-small-b pr-large-t">
    {{ 'myTrips.addTrips.title' | finLocalization }}
  </h2>
  <p class="mr-medium-b">{{ 'myTrips.addTrips.description' | finLocalization }}</p>
  <form class="ps-medium-b" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="flex">
      <div class="flex-2">
        <fcom-text-input
          *ngIf="
            formStatus() === FormStatus.INITIAL ||
            formStatus() === FormStatus.COMPLETE ||
            formStatus() === FormStatus.ERROR
          "
          [parentForm]="form"
          [controlName]="'bookingReference'"
          [label]="'SERVICE_FORMS.serviceForms.fields.reservationNumber.label' | finLocalization"
          [placeHolderText]="'SERVICE_FORMS.serviceForms.fields.reservationNumber.placeholder' | finLocalization"
          [required]="true"
          [translationErrorPrefix]="'SERVICE_FORMS.serviceForms.fields.reservationNumber'"
          [hideErrorLabel]="hideError"
          (blurEvent)="hideError = false"
        />
        <div *ngIf="formStatus() === FormStatus.LOADING" class="relative loader">
          <fcom-loader [loaderType]="LoaderTheme.INLINE" />
        </div>
      </div>
      <div class="flex-1 ps-xlarge-t ps-medium-l">
        <fcom-button
          [type]="ButtonType.SUBMIT"
          [disabled]="!form.valid || formStatus() === FormStatus.LOADING"
          [text]="'myTrips.addTrips.addButton' | finLocalization"
        />
      </div>
    </div>
  </form>
  <fcom-notification
    *ngIf="formStatus() === FormStatus.COMPLETE || formStatus() === FormStatus.ERROR"
    aria-live="polite"
    class="pr-small-y pr-clear-t mr-clear block"
    [theme]="formStatus() === FormStatus.ERROR ? NotificationTheme.ALERT : NotificationTheme.INFO"
    [iconName]="formStatus() === FormStatus.ERROR ? SvgLibraryIcon.INFO : SvgLibraryIcon.CHECKMARK"
  >
    {{ messageLabel | finLocalization }}
  </fcom-notification>
</div>
